/* eslint-disable @typescript-eslint/naming-convention */
// These are the locales supported in Tink Link
import countries from 'i18n-iso-countries';
import { en } from './langs/en';

countries.registerLocale(en);

export enum LocaleCode {
  CS = 'cs_CZ',
  DA = 'da_DK',
  DE = 'de_DE',
  EN = 'en_US',
  EE = 'et_EE',
  ES = 'es_ES',
  FI = 'fi_FI',
  FR = 'fr_FR',
  IT = 'it_IT',
  LT = 'lt_LT',
  LV = 'lv_LV',
  NL = 'nl_NL',
  NO = 'no_NO',
  PT = 'pt_PT',
  PL = 'pl_PL',
  SV = 'sv_SE',
}

export enum LanguageCode {
  cs = 'cs',
  da = 'da',
  de = 'de',
  et = 'et',
  // eslint-disable-next-line @typescript-eslint/no-shadow
  en = 'en',
  es = 'es',
  fi = 'fi',
  fr = 'fr',
  it = 'it',
  lt = 'lt',
  lv = 'lv',
  nl = 'nl',
  no = 'no',
  pt = 'pt',
  pl = 'pl',
  sv = 'sv',
}

export const LOCALES = [
  LocaleCode.CS,
  LocaleCode.DA,
  LocaleCode.DE,
  LocaleCode.EE,
  LocaleCode.EN,
  LocaleCode.ES,
  LocaleCode.FI,
  LocaleCode.FR,
  LocaleCode.IT,
  LocaleCode.LT,
  LocaleCode.LV,
  LocaleCode.NL,
  LocaleCode.NO,
  LocaleCode.PT,
  LocaleCode.PL,
  LocaleCode.SV,
];

export const LANGUAGES = [
  LanguageCode.cs,
  LanguageCode.da,
  LanguageCode.de,
  LanguageCode.et,
  LanguageCode.en,
  LanguageCode.es,
  LanguageCode.fi,
  LanguageCode.fr,
  LanguageCode.it,
  LanguageCode.lt,
  LanguageCode.lv,
  LanguageCode.nl,
  LanguageCode.no,
  LanguageCode.pt,
  LanguageCode.pl,
  LanguageCode.sv,
];

// These are the locales supported in Tink Link we show publicly (eg. in select controls)
export const PUBLIC_LOCALES = [
  LocaleCode.CS,
  LocaleCode.DA,
  LocaleCode.DE,
  LocaleCode.EE,
  LocaleCode.EN,
  LocaleCode.ES,
  LocaleCode.FI,
  LocaleCode.FR,
  LocaleCode.IT,
  LocaleCode.LT,
  LocaleCode.LV,
  LocaleCode.NL,
  LocaleCode.NO,
  LocaleCode.PT,
  LocaleCode.PL,
  LocaleCode.SV,
];

export enum MarketCode {
  AT = 'AT',
  BE = 'BE',
  BG = 'BG',
  BR = 'BR',
  CA = 'CA',
  CH = 'CH',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DK = 'DK',
  EE = 'EE',
  ES = 'ES',
  FI = 'FI',
  FO = 'FO',
  FR = 'FR',
  GB = 'GB',
  GR = 'GR',
  IE = 'IE',
  IT = 'IT',
  LT = 'LT',
  LV = 'LV',
  MT = 'MT',
  MX = 'MX',
  NL = 'NL',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  SE = 'SE',
  SG = 'SG',
  SK = 'SK',
  US = 'US',
}

// These are the markets enabled in Tink Link
export const MARKETS = [
  MarketCode.AT,
  MarketCode.BE,
  MarketCode.BG,
  MarketCode.BR,
  MarketCode.CA,
  MarketCode.CH,
  MarketCode.CY,
  MarketCode.CZ,
  MarketCode.DE,
  MarketCode.DK,
  MarketCode.EE,
  MarketCode.ES,
  MarketCode.FI,
  MarketCode.FO,
  MarketCode.FR,
  MarketCode.GB,
  MarketCode.GR,
  MarketCode.IE,
  MarketCode.IT,
  MarketCode.LV,
  MarketCode.LT,
  MarketCode.MT,
  MarketCode.MX,
  MarketCode.NL,
  MarketCode.NO,
  MarketCode.PL,
  MarketCode.PT,
  MarketCode.RO,
  MarketCode.SE,
  MarketCode.SG,
  MarketCode.SK,
  MarketCode.US,
];

// (For aggregation and transactions) These are the markets enabled in Tink Link we show publicly (eg. in select controls)
export const PUBLIC_MARKETS = [
  MarketCode.AT,
  MarketCode.BE,
  MarketCode.CZ,
  MarketCode.DE,
  MarketCode.DK,
  MarketCode.EE,
  MarketCode.ES,
  MarketCode.FI,
  MarketCode.FR,
  MarketCode.GB,
  MarketCode.IE,
  MarketCode.IT,
  MarketCode.LT,
  MarketCode.LV,
  MarketCode.NL,
  MarketCode.NO,
  MarketCode.PL,
  MarketCode.PT,
  MarketCode.SE,
];

// (For payment) These are the markets enabled in Tink Link we show publicly (eg. in select controls)
export const PUBLIC_PAYMENT_MARKETS = [
  MarketCode.GB,
  MarketCode.SE,
  MarketCode.FR,
  MarketCode.IT,
  MarketCode.PT,
  MarketCode.DE,
  MarketCode.ES,
  MarketCode.FI,
  MarketCode.AT,
  MarketCode.NO,
  MarketCode.LT,
  MarketCode.EE,
  MarketCode.NL,
  MarketCode.PL,
  MarketCode.DK,
  MarketCode.IE,
];

// (For Income Check) These are the markets enabled in Tink Link we show publicly (eg. in select controls)
export const PUBLIC_INCOME_CHECK_MARKETS = [
  MarketCode.BE,
  MarketCode.DE,
  MarketCode.ES,
  MarketCode.FI,
  MarketCode.FR,
  MarketCode.GB,
  MarketCode.IE,
  MarketCode.IT,
  MarketCode.NL,
  MarketCode.NO,
  MarketCode.PT,
  MarketCode.SE,
];

// (For Risk Decisioning) These are the markets enabled in Tink Link we show publicly (eg. in select controls)
export const PUBLIC_RISK_DECISIONING_MARKETS = [
  MarketCode.DE,
  MarketCode.FR,
  MarketCode.GB,
  MarketCode.SE,
];

// (For Account Check) These are the markets enabled in Tink Link we show publicly (eg. in select controls)
export const PUBLIC_ACCOUNT_CHECK_MARKETS = [
  MarketCode.BE,
  MarketCode.CZ,
  MarketCode.DE,
  MarketCode.DK,
  MarketCode.ES,
  MarketCode.FI,
  MarketCode.FR,
  MarketCode.GB,
  MarketCode.IT,
  MarketCode.NL,
  MarketCode.NO,
  MarketCode.PL,
  MarketCode.SE,
  MarketCode.EE,
  MarketCode.LT,
  MarketCode.LV,
  MarketCode.PT,
];

// (For Business Account Check) These are the markets enabled in Tink Link we show publicly (eg. in select controls)
export const PUBLIC_BUSINESS_ACCOUNT_CHECK_MARKETS = [MarketCode.GB, MarketCode.DE];

// (For Assets and Liabilities) These are the markets enabled in Tink Link we show publicly (eg. in select controls)
export const PUBLIC_ASSETS_AND_LIABILITIES_MARKETS = [MarketCode.ES, MarketCode.SE];

// (For Risk Insights) These are the markets enabled in Tink Link we show publicly (eg. in select controls)
export const PUBLIC_RISK_INSIGHTS_MARKETS = [
  MarketCode.ES,
  MarketCode.FI,
  MarketCode.FR,
  MarketCode.NL,
  MarketCode.SE,
  MarketCode.GB,
  MarketCode.DE,
];

// (For Expense Check) These are the markets enabled in Tink Link we show publicly (eg. in select controls)
export const PUBLIC_EXPENSE_CHECK_MARKETS = [
  MarketCode.DE,
  MarketCode.FR,
  MarketCode.GB,
  MarketCode.SE,
];

export type CountryCodeToNameMapping = { [code in MarketCode]: string };

const translateCountryCodes = (countryCodes: MarketCode[] = [], lang = 'en') =>
  countryCodes.reduce(
    (accumulator, code) => ({
      ...accumulator,
      [code]: countries.getName(code, lang),
    }),
    {} as CountryCodeToNameMapping
  );

export const PUBLIC_MARKETS_TRANSLATED = {
  en: translateCountryCodes(PUBLIC_MARKETS, 'en'),
};

export const MARKETS_TRANSLATED = {
  en: translateCountryCodes(MARKETS, 'en'),
};

export type OptionType<T = string> = {
  value: T;
  label: string;
};

export type MarketOption = OptionType<MarketCode>;

const marketsToOptions = (markets: MarketCode[]): MarketOption[] =>
  markets.map((marketCode) => ({
    value: marketCode,
    label: MARKETS_TRANSLATED.en[marketCode] || marketCode,
  }));

type MultilingualMarketCodeMap = {
  [key in MarketCode]?: LanguageCode[];
};

/*
 set the default language always as first item. getDefaultLocaleForMultilingualMarket depends on that
 */
export const MULTILINGUAL_MARKETS: MultilingualMarketCodeMap = {
  [MarketCode.BE]: [LanguageCode.en, LanguageCode.fr, LanguageCode.nl],
};

export const checkIsMarketMultilingual = (marketCode: MarketCode): boolean => {
  return Boolean(MULTILINGUAL_MARKETS[marketCode]);
};

const sortByLabel = <T>(a: OptionType<T>, b: OptionType<T>) => {
  // ignore upper and lowercase
  const labelA = a.label.toUpperCase();
  const labelB = b.label.toUpperCase();

  if (labelA < labelB) {
    return -1;
  }

  if (labelA > labelB) {
    return 1;
  }

  return 0;
};

const sortOptionsByLabel = <T>(options: OptionType<T>[]): OptionType<T>[] => {
  return options.sort(sortByLabel);
};

const marketCodesToSortedOptions = (marketCodes: MarketCode[]) => {
  return sortOptionsByLabel(marketsToOptions(marketCodes));
};

export const publicMarketOptions = marketCodesToSortedOptions(PUBLIC_MARKETS);

export const getPublicMarketOptions = (markets: MarketCode[]) =>
  marketCodesToSortedOptions(markets);

export const getPublicLocaleOptions = (translateFn: (locale: string) => string): OptionType[] => {
  return PUBLIC_LOCALES.map((locale) => ({
    value: locale,
    label: translateFn(locale),
  })).sort(sortByLabel);
};

export const getLanguageOptions = (translateFn: (locale: string) => string): OptionType[] => {
  return LANGUAGES.map((lang) => ({
    value: lang,
    label: translateFn(lang),
  })).sort(sortByLabel);
};
